export default __webpack_public_path__ + "static/media/message.be8245be.PNG";